import { getDb } from "../services/remote";
export const get = async () => {
  const remoteDb = getDb();
  const snapshot = await remoteDb.ref("/data").once("value");
  return snapshot.val();
};
